<template>
  <div class="site-search">

    <span
      class="bg"
      @click="closeAll()"
      v-show="open_live || open_suggested"
    ></span>

    <div class="content-max-width">

      <div class="search flex">
        <button>
          <!-- <span class="material-icons-outlined">search</span> -->
          <img src="/images/ico-search.svg" alt="Host Service Search">
        </button>

        <input
          type="text"
          placeholder="Start typing..."
          @focus="open_suggested = true"
          v-model="keyword"
          ref="keyword"
          v-debounce:750ms="watchInputSearch"
          @keyup.enter="redirectToSearchResults"
        >

        <button @click="closeAll()">
          <span class="material-icons-outlined">clear</span>
        </button>
      </div>

      <div
        class="output suggested"
        v-if="open_suggested && !open_live"
      >
        <h4>Popular Searches</h4>
        <a
          v-for="(item, index) of suggested"
          :href="item.url"
          :key="index"
        >
          {{ item.title }}
        </a>
      </div>

      <div
        class="output live"
        v-if="open_live"
      >
        <div class="suggested">

          <h4>Suggested Searches</h4>
          <a
            v-for="item of results"
            :href="item.url"
            :key="item.id"
          >
            {{ item.title }}
          </a>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import { debounce } from 'vue-debounce'
export default {
  props: [
    'suggested'
  ],

  data () {
    return {
      xhr_errors: null,
      loading: false,
      open_live: false,
      open_suggested: false,
      url:'/api/products',
      keyword: '',
      searching: false,
      results: []
    }
  },

  methods: {
    watchInputSearch (val) {
      if (val.length > 2) {
        this.liveSearch()
      } else {
        this.open_suggested = true
        this.open_live = false
      }
    },

    redirectToSearchResults () {
      window.location.href = '/products?keyword=' + this.keyword
    },

    closeAll () {
      this.open_live = false
      this.open_suggested = false
      this.search = ''
    },

    liveSearch () {
      this.loading = true
      this.open_suggested = false
      this.open_live = true
      this.searching = true

      let url = '/api/products?per_page=10'

      if (this.keyword !== '') {
        url += '&keyword=' + this.keyword
      }

      window.axios.get(url)
        .then(res => {
          this.open_live = true
          this.results = res.data.data
        })
        .catch(error => {
          console.log("FAIL", error)
          this.xhr_errors = error.response.data.errors
        })
        .finally(() => {
          this.loading = false
          this.searching = false
        })
    }

  }
}
</script>

<style lang="scss" scoped>
@import "../../sass/core/variables.scss";

.site-search {
  position: absolute;
  top: 90px;
  left: 0;

  width: 100%;

  background: #F9F9F9;
  border-top: 1px solid #D9D9D9;

  @media (min-width: $mediumish) {
  }

  .search {
    button {
      width: 20px;
      padding: 0;

      span {
        font-size: 22px;
        line-height: 56px;
        color: $color-2;
      }

      img {
        height: 18px;
        margin: 19px 0 0;
      }
    }
    
    input {
      position: relative;
      z-index: 1;

      // width: 100%;
      width: calc(100% - 40px);
      height: 56px;
      margin: 0;
      padding-left: 6px;

      background: #F9F9F9;
      border: none;
      outline: none;

      &::placeholder {
        font-size: 15px;
        color: rgba(#3B3E40, .5);
      }
    }
  }

  .output {
    position: absolute;
    top: 60px;

    width: 100%;
    max-width: 380px;
    // height: 250px;
    padding: 22px 20px;

    background: white;
    border-radius: 3px;
    box-shadow: 0 2px 10px 0 rgba(107,111,116,0.3);

    z-index: 10;

    h4 {
      margin-bottom: 8px;

      font-weight: 500;
      color: $color-2;
    }

    a {
      display: block;
      margin-bottom: 6px;

      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      color: $color-1;

      &:hover { color: $color-2; }
      &:last-child { margin-bottom: 0; }
    }
  }

  .bg {
    position: fixed;
    top: 0px;
    left: 0px;

    width: 100%;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/HeaderSearch.vue